"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = require("@emotion/react");
var react_2 = require("react");
var recoil_1 = require("recoil");
var react_hook_form_1 = require("react-hook-form");
var Styled = __importStar(require("./LoginPage.styled"));
var logo_admin_272_svg_1 = __importDefault(require("@/assets/svg/logo-admin-272.svg"));
var minsour_logo_200_svg_1 = __importDefault(require("@/assets/svg/minsour-logo-200.svg"));
var minsour_sad_200_svg_1 = __importDefault(require("@/assets/svg/minsour-sad-200.svg"));
var components_1 = require("@/components");
var Input_component_1 = require("@/components/common/Input/Input.component");
var Button_component_1 = require("@/components/common/Button/Button.component");
var api = __importStar(require("@/api"));
var login_1 = require("@/store/login");
var constants_1 = require("@/constants");
var ERROR_MESSAGE = {
    AUTH_FAILED: '아이디 또는 비밀번호를 잘못 입력했습니다.',
};
var LoginPage = function () {
    var _a = __read((0, react_2.useState)(false), 2), isLoading = _a[0], setLoading = _a[1];
    var _b = __read((0, react_2.useState)(''), 2), error = _b[0], setError = _b[1];
    var _c = (0, react_hook_form_1.useForm)(), handleSubmit = _c.handleSubmit, register = _c.register;
    var handleSetError = function (param) {
        setError(param);
    };
    var handleLogin = (0, recoil_1.useRecoilCallback)(function (_a) {
        var set = _a.set;
        return function (_a) {
            var username = _a.username, password = _a.password;
            return __awaiter(void 0, void 0, void 0, function () {
                var data, e_1;
                return __generator(this, function (_b) {
                    switch (_b.label) {
                        case 0:
                            _b.trys.push([0, 2, 3, 4]);
                            setLoading(true);
                            return [4 /*yield*/, api.postLogin({ username: username, password: password })];
                        case 1:
                            data = (_b.sent()).data;
                            localStorage.setItem(constants_1.ACCESS_TOKEN, data.accessToken);
                            set(login_1.$me, data);
                            return [3 /*break*/, 4];
                        case 2:
                            e_1 = _b.sent();
                            handleSetError(ERROR_MESSAGE.AUTH_FAILED);
                            return [3 /*break*/, 4];
                        case 3:
                            setLoading(false);
                            return [7 /*endfinally*/];
                        case 4: return [2 /*return*/];
                    }
                });
            });
        };
    });
    return ((0, jsx_runtime_1.jsx)(Styled.LoginPageWrapper, { children: (0, jsx_runtime_1.jsxs)(Styled.LoginContainer, __assign({ isError: !!error, onSubmit: handleSubmit(handleLogin) }, { children: [(0, jsx_runtime_1.jsx)(logo_admin_272_svg_1.default, {}, void 0), (0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)(components_1.Input, __assign({}, register("username", { required: true }), { "$size": Input_component_1.InputSize.md, id: "id", placeholder: "\uC544\uC774\uB514\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694", label: "", onFocus: function () { return handleSetError(''); } }), void 0), (0, jsx_runtime_1.jsx)(components_1.Input, __assign({}, register("password", { required: true }), { type: "password", "$size": Input_component_1.InputSize.md, id: "password", placeholder: "\uBE44\uBC00\uBC88\uD638\uB97C \uC785\uB825\uD574\uC8FC\uC138\uC694", label: "", errorMessage: error, onFocus: function () { return handleSetError(''); } }), void 0)] }, void 0), (0, jsx_runtime_1.jsx)(components_1.Button, { type: "submit", shape: Button_component_1.ButtonShape.primary, label: "\uB85C\uADF8\uC778", isLoading: isLoading }, void 0), error ? (0, jsx_runtime_1.jsx)(minsour_sad_200_svg_1.default, {}, void 0) : (0, jsx_runtime_1.jsx)(minsour_logo_200_svg_1.default, {}, void 0)] }), void 0) }, void 0));
};
exports.default = LoginPage;
